import FinancialClaimModule from './Financial'
import BankingModule from './Banking'
import PropertyModule from './Property'
import CommercialModule from './Commercial'
import CriminalModule from './Criminal'
import FraudModule from './Fraud'
import BreachOfTrustModule from './BreachOfTrust'
import PersonnelEmbezzlementModule from './PersonnelEmbezzlement'
import PropertyTheftModule from './PropertyTheft'
import CybercrimeModule from './Cybercrime'
import MissingModule from './Missing'
import AccidentModule from './Accident'
import PersonnelDisputeModule from './PersonnelDispute'
import PublicComplaintModule from './PublicComplaint'
import SocialSecuritySubModule from './SocialSecurity'
import CourtOfJusticeSubModule from './CourtOfJustice'

export default {
  subModules: {
    financialClaim: FinancialClaimModule,
    banking: BankingModule,
    property: PropertyModule,
    commercial: CommercialModule,
    criminal: CriminalModule,
    fraud: FraudModule,
    breachOfTrust: BreachOfTrustModule,
    personnelEmbezzlement: PersonnelEmbezzlementModule,
    propertyTheft: PropertyTheftModule,
    cybercrime: CybercrimeModule,
    missing: MissingModule,
    personnelDispute: PersonnelDisputeModule,
    accident: AccidentModule,
    publicComplaint: PublicComplaintModule,
    socialSecurity: SocialSecuritySubModule,
    courtOfJustice: CourtOfJusticeSubModule,
  },
}
